import OrderFormTanke from '@components/components/OrderFormTanke/OrderFormTanke';
import React, { useMemo } from 'react';

const CmsOrderFormTanke = ({ product: initialProduct, ...other }) => {
  const product = useMemo(() => {
    const searchParams = new URLSearchParams(window.location.search);
    if (!searchParams.has('tarif')) {
      return initialProduct;
    }
    return searchParams.get('tarif');
  }, [window.location.search]);
  return <OrderFormTanke {...other} product={product} />;
};

export default CmsOrderFormTanke;
